<mat-form-field class="full-width">
  <mat-label>{{ label }}</mat-label>
  <div class="position-relative">
    @if (showIcon) {
      <i class="dropdown-icon" [ngClass]="iconClass"></i>
    }
    <input type="text" class="zint-autocomplete" [placeholder]="placeholder" matInput [formControl]="autocompleteControl"
    [matAutocomplete]="zintAuto" (blur)="onBlur()">
  </div>
  <mat-autocomplete #zintAuto="matAutocomplete" [displayWith]="displayFn" (optionSelected)="emitSelectedOption($event)">
    @for (option of filteredOptions$ | async; let optIndex=$index; track optIndex) {
    <mat-option class="text-break py-1" [value]="option">{{ getOptionDisplay(option) }}
      @if(subscriptString || subscriptKey){
        <small class="subscript">{{subscriptString || option[subscriptKey]}}</small>
      }
    </mat-option>
    } @empty {
    <mat-option disabled><i class="fal fa-magnifying-glass-minus fa-xs mr-1"></i>
     <small>No match found</small>
    </mat-option>
    }
  </mat-autocomplete>
</mat-form-field>